// Header.jsx
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { addToast } from '../storage/slices/ToastSlice';
import { logout, resetLogoutStatus } from '../storage/slices/AuthSlice';
import { useData } from '../data/general/DataContext';
import { FaUser, FaDoorClosed } from 'react-icons/fa';
import gsap from 'gsap';
import logo from '../assets/images/logo.png';

function Header() {
  const dispatch = useDispatch();
  const { sidebarMode, setSidebarMode, windowMode } = useData();
  const toggleRef = useRef(); 
  const profileRef = useRef();
  const [profileDropdown, setProfileDropdown] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setProfileDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    await dispatch(logout());
    await dispatch(resetLogoutStatus());
    navigate("/girisyap");
    dispatch(addToast({ background: 'danger', icon: 'logout', message: 'Çıkış Yaptınız!', delay: 2000 }));
  };

  const toggleSidebar = () => {
    setSidebarMode(!sidebarMode);

    // GSAP animasyonu: sola kayma + transparan → normal
    gsap.fromTo(
      toggleRef.current,
      { x: -20, opacity: 0 },
      { x: 0, opacity: 1, duration: 0.5, ease: "power2.out" }
    );
  };

  if (windowMode !== 'mobile') return null;

  return (
    <div className='header-container d-flex justify-content-between align-items-center'>
      {/* Sol kısım: Logo + Hamburger */}
      <div className="d-flex align-items-center">
        <img src={logo} alt="logo" className="header-logo" style={{ height: '40px', marginRight: '10px' }} />
      </div>

      {/* Sağ kısım: Profil */}
      <div className='header-content d-flex align-items-center'>
        <div ref={profileRef} className='header-dropdown-container'>
          <button className='header-dropdown-button' onClick={() => setProfileDropdown(!profileDropdown)}>
            <FaUser />
          </button>
          {profileDropdown && (
            <div className='header-dropdown-content'>
              <button className='header-dropdown-content-button' onClick={handleLogout}>
                <FaDoorClosed />
                <span>Çıkış Yap</span>
              </button>
            </div>
          )}
        </div>

        <button
          ref={toggleRef}
          className={`sidebar-toggle-btn ${sidebarMode ? 'open' : ''}`}
          onClick={toggleSidebar}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>
  );
}

export default Header;
